class StaffScript {
	constructor(el, opt) {
		this.el = el;
		if($(this.el).length){
			this.event();
		}
	}

	event(){
    $('.js-modal-trigger').on("click", function() {
      if($(`${$(this).attr('href')}`).length) {
        $(`${$(this).attr('href')}`).addClass('is-active');
        $("body").css({overflow: 'hidden'});
      }
    })

    $('.js-overlay, .js-close').on('click', function() {
      $('.s-hair-type01__modal, .s-member-type01-modal, .s-member-modal, .s-staff-type01-modal').removeClass('is-active');
      $("body").css({overflow: 'inherit'});
    })
  }
}